import React, { Component } from 'react';
import ReactTable from "react-table";
import "react-table/react-table.css";
import { withRouter } from 'react-router-dom'
import couterpart from 'counterpart';
import {ToastsContainer, ToastsStore} from 'react-toasts';

import MasterDataService from '../services/MasterDataService';

import WorkOrderDataService from '../services/WorkOrderDataService';
import WorkOrderUtil from '../utilities/WorkOrderUtil';
import StatisticService from '../services/StatisticService';

class KhaiHqByPackage extends Component {
  constructor () {
    super();
    
    this.state = {
      selected: null,
      shipPackageStatistics: [],
      allStatus: [],
      columns : [{
          Header: couterpart.translate('khaihq_pakage'),
          accessor: 'shipCode',
          width: 150
        },{
          Header: couterpart.translate('khaihq_chungloaihh'),
          accessor: 'chungLoaiHh',
          filterable: false
        },{
          Header: couterpart.translate('khaihq_chotdshq'),
          accessor: 'count'
        },{           
          Header: couterpart.translate('khaihq_thuctedshq'),
          accessor: 'countTt',
          filterable: false  
        },{
          Header: couterpart.translate('khaihq_chenhlech'),
          accessor: 'chenhLech',
          width: 150
        }]
    };
  }

  componentDidMount () {
    let code = '0';
    if ((this.props.shipCode === null) || (this.props.shipCode === undefined) || (this.state.shipCode === this.props.shipCode) || (this.props.shipCode === '')){
      return;
    }

    code = this.props.shipCode;
    StatisticService.getKiemTraHq(code).then(data => {
      if (data !== undefined && data !== null) {
        this.setState({ shipPackageStatistics: data })
      }
    });
  }

  linkToDetails(row){
      return(
          <label className="label_link" href="#!" onClick={() => {this.handleEdit(row)}}>{row.original.workOrderNo}</label>
      )
  }    

  render() {
    const work_orders_of_order = couterpart.translate('work_orders_of_order');
    return (
          <div>
              <hr/>
              <ToastsContainer store={ToastsStore} position="bottom_center" />
              <div><b>{work_orders_of_order} {this.props.orderNo}</b></div>
              <ReactTable
                NoDataComponent={() => null} 
                previousText={"<"}
                nextText={">"}              
                data={this.state.shipPackageStatistics}
                columns={this.state.columns}
                defaultPageSize = {10}
                showPageSizeOptions = {true}
                pageSizeOptions = {[3, 5, 10, 20, 50, 100]}
                getTrProps={(state, rowInfo, column) => { 
                  if (rowInfo && rowInfo.row) {
                    return {
                      onClick: (e) => {
                        this.setState({
                          selected: rowInfo.index,
                          workOrderId: rowInfo.original.id
                        }, () => {
                          WorkOrderUtil.saveItem('shipPackages.workorders.selectedIndex', this.state.selected)
                        })
                      },
                      style: {
                        background: rowInfo.index === this.state.selected ? '#DCDCDC' : 'white',
                        color: rowInfo.index === this.state.selected ? 'black' : 'black'
                      }
                    }
                  }else{
                    return {}
                  }
                }
              }
              />
          </div>      
    )
  }
}

export default withRouter(KhaiHqByPackage);